import { render, staticRenderFns } from "./edit-procedure-template.vue?vue&type=template&id=0282f2b7&scoped=true&"
import script from "./edit-procedure-template.vue?vue&type=script&lang=js&"
export * from "./edit-procedure-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0282f2b7",
  null
  
)

export default component.exports